import { NgModule } from '@angular/core';
import { AppCoreModule } from '../core/app-core.module';
import { FormEngineModule } from '../form/form-engine.module';
import { RegisterLoginComponent } from './register-login/register-login.component';
import { UploadMultiComponent } from './upload-multi/upload-multi.component';

@NgModule({
  imports: [
    AppCoreModule,
    FormEngineModule,
  ],
  declarations: [
    RegisterLoginComponent,
    UploadMultiComponent,
  ],
  exports: [
    RegisterLoginComponent,
    UploadMultiComponent,
  ]
})
export class ComponentModule { }



// WEBPACK FOOTER //
// ./src/app/component/component.module.ts